(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/models/syndicate.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/models/syndicate.js');
"use strict";


(function (Backbone, _, async, svs, Radio) {
  'use strict';

  let api = 0;
  if (svs.core.detect.feature('ft-its-api-version')) {
    api = 1;
  }
  svs.syndicate.core.models.Syndicate = Backbone.Model.extend({
    idAttribute: 'syndicateId',
    defaults() {
      return {
        wagerCount: svs.syndicate.core.data.constants.NUMBER_OF_WAGERS_IN_OVERVIEW
      };
    },
    url() {
      let url = "".concat(svs.core.jupiter.url(), "/multifetch?urls=/social/1/syndicates/").concat(this.get('syndicateId'), "|/social/1/syndicates/").concat(this.get('syndicateId'), "/wagers?count=").concat(this.get('wagerCount'));
      const fetchMode = this.get('fetchMode');
      switch (fetchMode) {
        case 'WAGERS':
          url = "".concat(svs.core.jupiter.url(), "/social/1/syndicates/").concat(this.get('syndicateId'), "/wagers");
          break;
        default:
      }
      this.unset('fetchMode');
      return url;
    },
    initialize(options) {
      let parsed;
      _.bindAll(this, 'isActiveMember', 'getMemberNameFromId', 'getMemberNamesFromIds', 'onDepositMade');
      this.listenTo(this, 'error', this.modelError);
      this.listenTo(this, 'sync', this.modelFetched);
      this.getChannel().on('DepositMade', this.onDepositMade);
      this.getChannel().on('WithdrawMade', this.onDepositMade);
      if (options) {
        parsed = this.parseSyndicate(options, parsed);
        this.set(parsed);
      }
    },
    parse(response) {
      if (!this.get('wagers')) {
        this.set('wagers', new svs.syndicate.core.collections.Wagers());
      }
      if (response.responses && _.isArray(response.responses)) {
        if (response.responses[0].error && response.responses[0].error.code === svs.syndicate.core.data.constants.ERROR_CODES.NOT_AUTHORIZED) {
          if (!this.get('unauthorizedError')) {
            this.set('unauthorizedError', true, {
              silent: true
            });
            setTimeout(this.fetch.bind(this), 500);
            this.fetch();
            return;
          }
        }
        this.set('unauthorizedError', false, {
          silent: true
        });
        let parsed;
        parsed = this.parseSyndicate(response.responses[0], parsed);
        parsed = this.parseSyndicateWagers(response.responses[1], parsed);
        this.listenTo(this.get('currentMember'), 'change:memberState', this.updateActions);
        return parsed;
      }
      if (response.totalSyndicateBalance) {
        response.syndicateBalance = response.totalSyndicateBalance;
      }
      if (_.isArray(response.wagers)) {
        if (_.isUndefined(response.syndicateId)) {
          this.get('wagers').syndicateId = this.get('syndicateId');
          this.get('wagers').moreItems = response.wagers && response.wagers.length ? response.moreItems : false;
          this.get('wagers').reset(response.wagers);
          delete response.wagers;
          return response;
        }
        response.wagers = new svs.syndicate.core.collections.Wagers(response.wagers, {
          syndicateId: response.syndicateId,
          moreItems: response.wagers && response.wagers.length ? response.wagers[0].moreItems : false
        });
      }
      return response;
    },
    parseSyndicate(response, parsed) {
      const self = this;
      response = response.syndicate || response;
      response = this.parseSyndicateMembers(response);
      if (response.pendingInvitations) {
        response.invitations = response.pendingInvitations.invitations || [];
        response.invitations.forEach(invitee => {
          const now = new Date();
          invitee.currentMember = self.get('currentMember');
          invitee.syndicateModel = self;
          now.setSeconds(now.getSeconds() + invitee.ttl);
          invitee.expireDate = dateFns.format(now, 'd MMMM', {
            locale: dateFns.locales.sv
          });
        });
        this.set('invitees', new svs.syndicate.core.collections.Invitees(response.invitations || []));
        delete response.invitations;
        delete response.pendingInvitations.invitations;
        response.numberOfInvitations = response.pendingInvitations.numberOfInvitations;
        delete response.pendingInvitations.numberOfInvitations;
      }
      delete response.currentMember;
      parsed = response;
      return parsed;
    },
    parseSyndicateMembers(response) {
      let currentMember = null;
      if (response.members) {
        currentMember = _.where(response.members, {
          isCurrentMember: true
        })[0];
        for (let i = 0; i < response.members.length; i++) {
          response.members[i].currentMemberRole = currentMember.memberRole;
          response.members[i].syndicateId = response.syndicateId;
        }

        if (currentMember.memberRole & svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER === svs.syndicate.core.data.constants.SyndicateMemberPermissions.OWNER) {
          response.isCurrentMemberOwner = true;
        } else {
          response.isCurrentMemberOwner = false;
        }

        const partitionedMembers = _.partition(response.members, member => member.memberState === svs.syndicate.core.data.constants.syndicateMemberState.INACTIVE);
        if (!this.get('inactiveMembers') || this.has('inactiveMembers') && !(this.get('inactiveMembers') instanceof Backbone.Collection)) {
          this.set('inactiveMembers', new svs.syndicate.core.collections.Members(partitionedMembers[0]));
        }
        this.get('inactiveMembers').reset(partitionedMembers[0]);
        if (!this.has('members') || this.has('members') && !(this.get('members') instanceof Backbone.Collection)) {
          this.set('members', new svs.syndicate.core.collections.Members());
        }
        this.listenTo(this.get('members'), 'add remove', this.checkSyndicateState);
        this.get('members').reset(partitionedMembers[1]);
        if (currentMember.memberState === svs.syndicate.core.data.constants.syndicateMemberState.ACTIVE) {
          this.set('currentMember', this.get('members').where({
            isCurrentMember: true
          })[0]);
        } else {
          this.set('currentMember', this.get('inactiveMembers').where({
            isCurrentMember: true
          })[0]);
        }
        delete response.members;
      } else if (response.memberState) {
        this.set('members', new svs.syndicate.core.collections.Members());
        this.set('inactiveMembers', new svs.syndicate.core.collections.Members());
        const member = new svs.syndicate.core.models.Member({
          memberState: response.memberState,
          memberRole: response.memberRole,
          memberBalance: response.memberBalance
        });
        this.set('currentMember', member);
        if (member.get('memberState') === svs.syndicate.core.data.constants.syndicateMemberState.ACTIVE) {
          this.get('members').push(member);
        } else {
          this.get('inactiveMembers').push(member);
        }
      }
      return response;
    },
    parseSyndicateWagers(response, parsed) {
      if (response.wagers) {
        this.get('wagers').reset(response.wagers);
        this.get('wagers').syndicateId = this.get('syndicateId');
        this.get('wagers').moreItems = response.moreItems;
        parsed.hasMoreWagers = response.moreItems;
        parsed.numberOfWagers = response.wagers.length;
        parsed.hasWagers = response.wagers.length > 0;
        this.get('wagers').each(wager => {
          wager.set({
            syndicateId: parsed.syndicateId
          }, {
            silent: true
          });
        });
      }
      delete response.wagers;
      return parsed;
    },
    fetchWagers() {
      this.set('fetchMode', 'WAGERS');
      this.fetch();
    },
    toFull(callback) {
      const self = this;
      this.set('wagerCount', svs.syndicate.core.data.constants.WAGERS_PER_LOAD, {
        silent: true
      });
      this.fetch({
        reset: true,
        success() {
          if (!self.has('members')) {
            self.set('members', new svs.syndicate.core.collections.Members());
            self.listenTo(this.get('members'), 'add remove', this.checkSyndicateState);
          }
          callback();
        }
      });
    },
    onDepositMade(option) {
      if (option.syndicateId === this.get('syndicateId')) {
        const fetch = this.fetch.bind(this);
        setTimeout(() => {
          fetch({
            force: true
          });
        }, 1500);
      }
    },
    checkSyndicateState() {
      let minAmount = this.get('members').models ? svs.utils.format.CurrencyFromJupiterString(this.get('members').models[0].get('memberBalance')) : 0;
      let syndicateBalance = 0;
      let memberBalance = 0;
      _.each(this.get('members').models, member => {
        memberBalance = svs.utils.format.CurrencyFromJupiterString(member.get('memberBalance'));
        minAmount = Math.min(minAmount, memberBalance);
        syndicateBalance += memberBalance;
      });

      const playableAmount = this.get('members').length < 2 ? 0 : minAmount * this.get('members').length + svs.utils.format.CurrencyFromJupiterString(this.get('float'));
      this.updateSyndicate(playableAmount, syndicateBalance);
    },
    updateSyndicate(playableAmount, syndicateBalance) {
      const amount = playableAmount !== undefined ? playableAmount : svs.utils.format.CurrencyFromJupiterString(this.get('playableAmount'));
      const balance = syndicateBalance !== undefined ? syndicateBalance : svs.utils.format.CurrencyFromJupiterString(this.get('syndicateBalance'));
      const tooFewMembers = this.get('members').length < 2;
      this.set({
        tooFewMembers,
        playableAmount: svs.utils.format.CurrencyAsJupiterString(amount),
        syndicateBalance: balance
      });
    },
    getChannel() {
      return Radio.channel('syndicate');
    },
    modelError(model, error) {
      this.modelFetched();
      this.trigger('fetchError', model, error);
    },
    modelFetched() {
      this.updateActions();
    },
    updateActions() {
      const actions = [];
      if (!this.get('currentMember') || typeof this.get('currentMember') !== 'object') {
        return;
      }
      if (this.get('currentMember') instanceof Backbone.Model) {
        actions.push({
          actionClass: 'js-leave-syndicate-member',
          text: 'Lämna lag'
        });
        if (this.get('currentMember').get('memberState') === svs.syndicate.core.data.constants.syndicateMemberState.ACTIVE) {
          actions.push({
            actionClass: 'js-inactivate-member',
            text: 'Sätt dig vilande'
          });
        }
      }
      this.set({
        actions
      });
    },
    terminateSyndicate() {
      svs.syndicate.core.collections.getSyndicateCollectionInstance().terminateSyndicate(this);
    },
    leaveSyndicate() {
      svs.syndicate.core.collections.getSyndicateCollectionInstance().leaveSyndicate(this);
    },
    requestActivation() {
      svs.syndicate.core.collections.getSyndicateCollectionInstance().requestActivation(this);
    },
    removeInvitee(invitee, options, callback) {
      const self = this;
      svs.core.jupiter.delete("/social/".concat(3 + api, "/syndicates/").concat(this.get('syndicateId'), "/member?invitationId=").concat(invitee.get('invitationId')), response => {
        self.get('invitees').remove(invitee);
        self.set({
          numberOfInvitations: self.get('invitees').length,
          syndicateState: response.syndicateState,
          syndicateBalance: response.syndicateAmounts.playableAmount
        }, options);
        if (self.get('numberOfInvitations') === 0) {
          self.trigger('invitees:empty');
          setTimeout(() => {
            self.fetch({
              parse: true,
              force: true
            });
          }, 2000);
        }
        svs.syndicate.accept_invite.logger.debug("Successfully removed invitationId ".concat(invitee.get('invitationId'), " for syndicateId ").concat(self.get('syndicateId')));
        if (callback) {
          callback();
        }
      }, xhr => {
        if (callback) {
          callback(xhr);
        }
      });
    },
    removeInactive(memberId, options, callback) {
      const self = this;
      svs.core.jupiter.delete("/social/".concat(3 + api, "/syndicates/").concat(this.get('syndicateId'), "/member?memberId=").concat(memberId), () => {
        self.get('inactiveMembers').remove(self.get('inactiveMembers').where({
          customerId: memberId
        }));
        if (!options.silent) {
          setTimeout(() => {
            self.fetch({
              parse: true,
              force: true
            });
          }, 2000);
        }
        if (callback) {
          callback();
        }
      }, xhr => {
        if (callback) {
          callback(xhr);
        }
      });
    },
    activateMemberRequest(syndicateName, memberName, customerId, callback) {
      const titleTxt = "Vill du aktivera ".concat(memberName, " i laget ").concat(syndicateName, "?");
      this.activationDialog(titleTxt, customerId, callback);
    },
    activateMember(member) {
      const titleTxt = "Vill du aktivera ".concat(member.memberName(false), " i laget ").concat(this.get('syndicateName'), "?");
      const customerId = member.get('customerId');
      this.activationDialog(titleTxt, customerId);
    },
    activationDialog(titleTxt, customerId, callback) {
      const self = this;
      const actionDialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'spela-tillsammans',
        title: titleTxt,
        actions: [{
          title: 'Avbryt'
        }, {
          title: 'Bekräfta',
          showLoader: true,
          callback() {
            self.makeMemberActivationCall(customerId, actionDialog, callback);
          }
        }]
      });
      svs.ui.dialog.api.add(actionDialog);
    },
    makeMemberActivationCall(customerId, previousDialog, callbackToRequest) {
      const self = this;
      const jupiterOptions = {
        path: "/social/".concat(5 + api, "/syndicates/").concat(self.get('syndicateId'), "/member"),
        data: {
          memberId: customerId,
          reactivateMember: true
        }
      };
      const member = this.getMemberFromId(customerId);
      const memberIdentifier = member ? member.memberName(false, false) : customerId;
      const memberTextLW = member ? member.memberName(false, true) : 'medlemmen';
      const memberTextUC = member ? member.memberName(false, true) : 'Medlemmen';
      svs.core.jupiter.put(jupiterOptions, () => {
        svs.syndicate.syndicate_detail.logger.debug("Successfully activated user ".concat(memberIdentifier));
        if (member) {
          member.set('memberState', svs.syndicate.core.data.constants.syndicateMemberState.ACTIVE);
          self.get('members').add(member);
          self.get('inactiveMembers').remove(member);
        }
        const dialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          icon: 'thumbs-up',
          title: "".concat(memberTextUC, " har aktiverats."),
          actions: [{
            title: 'Okej',
            callback() {
              if (callbackToRequest) {
                callbackToRequest(dialog);
              } else {
                dialog.close();
              }
            }
          }]
        });
        svs.ui.dialog.api.add(dialog);
        if (previousDialog) {
          previousDialog.close();
        }
      }, xhr => {
        svs.ui.loader.hide();
        const errorCode = xhr.responseJSON.error.code;
        svs.syndicate.syndicate_detail.logger.error('Error trying to activate user ', memberIdentifier, 'error: ', xhr.textStatus);
        let errorMessage = {
          title: 'Tekniskt fel',
          text: "Det gick inte att aktivera ".concat(memberTextLW, ".")
        };
        if (errorCode === '22 108') {
          errorMessage = {
            title: "Medlemmen ".concat(memberTextLW, " \xE4r redan aktiverad")
          };
        }
        const dialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          type: svs.ui.dialog.type.ERROR,
          title: errorMessage.title,
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: errorMessage.text
          }],
          actions: [{
            title: 'Okej',
            callback() {
              location.reload();
            }
          }]
        });
        svs.ui.dialog.api.add(dialog);
        if (previousDialog) {
          previousDialog.close();
        }
      });
    },
    inactivateMember(member) {
      const memberName = member.get('isCurrentMember') ? 'dig' : member.memberName(false, false);
      let message = '';
      const memberBalance = member.get('memberBalance');

      if (svs.utils.format.CurrencyFromJupiterString(memberBalance) > 0) {
        message += "<p>".concat(svs.utils.format.Currency(memberBalance), " kr kommer att \xF6verf\xF6ras till ");
        message += member.get('isCurrentMember') ? 'ditt spelkonto' : "spelkontot tillh\xF6rande ".concat(member.memberName(false, false));
        message += '.</p>';
      }
      message += member.get('isCurrentMember') ? 'Du' : member.memberName(true, true);
      message += ' kommer fortsättningsvis att kunna följa alla lagaktiviteter förutom nya spel.';
      const actionDialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'rest',
        title: "<p>Vill du s\xE4tta ".concat(memberName, " vilande i laget?</p>"),
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: message
        }],
        actions: [{
          title: 'Avbryt'
        }, {
          title: 'Bekräfta',
          showLoader: true,
          callback: function () {
            actionDialog.close();
            this.inactivateMemberAction(member, actionDialog);
          }.bind(this)
        }]
      });
      svs.ui.dialog.api.add(actionDialog);
    },
    inactivateMemberAction(member, previousDialog) {
      const jupiterOptions = {
        path: "/social/".concat(1 + api, "/syndicates/").concat(this.get('syndicateId'), "/setshare"),
        data: {
          members: [member.get('customerId')],
          amount: '0,00',
          setShareType: 'TRANSFER_MONEY',
          comment: 'passive'
        }
      };
      svs.core.jupiter.post(jupiterOptions, () => {
        this.inactivateMemberSuccess(member, previousDialog);
      }, xhr => {
        this.inactivateMemberError(member, xhr, previousDialog);
      });
    },
    inactivateMemberSuccess(member, previousDialog) {
      svs.ui.loader.hide();
      svs.syndicate.syndicate_detail.logger.debug("Successfully inactivated user ".concat(member.memberName(false, false), ", customerId:").concat(member.get('customerId')));
      this.get('inactiveMembers').add(member);
      this.get('members').remove(member);
      if (member.get('isCurrentMember')) {
        this.set({
          memberState: svs.syndicate.core.data.constants.syndicateMemberState.INACTIVE
        });
      }
      member.set({
        memberState: svs.syndicate.core.data.constants.syndicateMemberState.INACTIVE,
        memberBalance: '0,00'
      });
      const message = svs.syndicate.core.templates.inactivate_success({
        name: member.get('isCurrentMember') ? 'Du' : member.memberName(false, false),
        syndicateName: this.get('syndicateName') ? this.get('syndicateName') : 'Laget',
        hasBalance: member.get('memberBalance') !== '0,00',
        balance: svs.utils.format.Currency(member.get('memberBalance')),
        isYourself: member.get('isCurrentMember')
      });
      svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'thumbs-up',
        title: message,
        actions: [{
          title: 'Okej'
        }]
      }));
      if (previousDialog) {
        previousDialog.close();
      }
      this.getChannel().trigger('InactivateMember', {
        syndicateId: this.get('syndicateId')
      });
    },
    inactivateMemberError(member, xhr, previousDialog) {
      svs.ui.loader.hide();
      svs.syndicate.syndicate_detail.logger.error('Error trying to inactivate user ', member.get('firstName'), 'error: ', xhr.statusText);
      const errorCode = xhr.responseJSON.error.code;
      let errorMessage = {
        title: 'Ett fel har inträffat',
        text: "Det gick inte att s\xE4tta ".concat(member.memberName(false), " vilande.")
      };
      if (errorCode === '22 108') {
        errorMessage = {
          title: "Medlemmen".concat(member.memberName(false), " \xE4r redan vilande")
        };
      }
      svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: errorMessage.title,
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: errorMessage.text
        }],
        actions: [{
          title: 'Okej',
          callback() {
            location.reload();
          }
        }]
      }));
      if (previousDialog) {
        previousDialog.close();
      }
    },
    addMembers(options, callback) {
      const self = this;
      const members = options.emails;
      const comment = options.comment;
      const initialDeposit = options.initialDeposit;
      const data = {
        path: "/social/".concat(4 + api, "/syndicates/").concat(this.get('syndicateId'), "/invitations"),
        data: {
          initialDeposit,
          syndicateId: this.get('syndicateId'),
          comment,
          invitees: members
        }
      };
      svs.core.jupiter.post(data, data => {
        svs.syndicate.core.logger.debug("Successfully requesting invitation message for: ".concat(self.get('syndicateName')));
        svs.syndicate.syndicate_add_members.invitationIds = data.invitationIds; 
        const invitees = members;
        for (let i = 0; i < invitees.length; i++) {
          const invitee = {};
          const now = new Date();
          invitee.email = invitees[i];
          invitee.invitationId = data.invitationIds[i];
          invitee.initialDepositAmount = initialDeposit;
          invitee.currentMember = self.get('currentMember');
          invitee.syndicateModel = self;
          invitee.ttl = 14 * 24 * 3600;
          now.setSeconds(now.getSeconds() + invitee.ttl);
          invitee.expireDate = dateFns.format(now, 'd MMMM', {
            locale: dateFns.locales.sv
          });
          self.get('invitees').add(invitee);
        }
        self.set({
          numberOfInvitations: self.get('invitees').length,
          syndicateState: data.syndicateState,
          syndicateBalance: data.syndicateAmounts.playableAmount,
          tooFewMembers: self.get('members').length < 2
        });
        if (callback) {
          callback();
        }
      }, xhr => {
        svs.syndicate.syndicate_add_members.logger.error("Error requesting invitation messages: ".concat(xhr.responseText));
        if (callback) {
          callback(parseInt(xhr.responseJSON.error.code.replace(' ', ''), 10));
        }
      });
    },
    memberIds() {
      return _.pluck(_.pluck(this.get('members').models, 'attributes'), 'customerId');
    },
    inactiveMemberIds() {
      return _.pluck(_.pluck(this.get('inactiveMembers').models, 'attributes'), 'customerId');
    },
    getOwner() {
      return this.get('members') ? this.get('members').find(member => member.isOwner()) : null;
    },
    isActiveMember() {
      if (!this.get('members')) {
        return false;
      }
      const myMembers = this.get('members').models;
      const member = _.find(myMembers, m => m.active());
      return Boolean(member);
    },
    getMemberFromId(customerId) {
      return _.find(this.get('members').models.concat(this.get('inactiveMembers').models), member => member.get('customerId') === customerId);
    },
    getMemberNameFromId(customerId) {
      const member = this.getMemberFromId(customerId);
      let retStr = 'Före detta medlem';
      if (member) {
        retStr = "".concat(member.get('firstName'), " ").concat(member.get('lastName'));
      }
      if (retStr === ' ') {
        retStr = 'Anonym';
      }
      return retStr;
    },
    getMemberNamesFromIds(idArr) {
      const memberNames = [];
      const self = this;
      _.each(idArr, customerId => {
        memberNames.push(self.getMemberNameFromId(customerId));
      });
      return memberNames;
    },
    isCurrentMemberOwner() {
      return this.get('currentMember') && this.get('currentMember').isOwner();
    }
  });
})(Backbone, _, async, svs, Backbone.Radio);

 })(window);